var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMexcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6948_102096)",
    filter: "url(#filter0_d_6948_102096)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5,
    cy: 49.406,
    rx: 40,
    ry: 39.9988,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9964 40.2201L55.503 26.8739C53.8676 24.0945 49.84 24.0694 48.2534 26.9991L40.3937 40.8712C38.9292 43.4253 40.7354 46.6053 43.6889 46.6053H59.4816C62.4351 46.6303 64.6564 43.3251 62.9964 40.2201Z",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1844 41.2712L51.7206 40.4449C51.2812 39.6687 50.3293 38.016 50.3293 38.016L43.9829 26.698C42.3475 24.194 38.4421 23.9687 36.8067 27.1487L29.4107 40.2696C27.8729 43.024 29.7036 46.6047 33.0233 46.6297H48.7183H55.4063H59.3851C55.3331 46.6548 54.0395 44.4763 52.1844 41.2712Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1833 41.2222L51.7195 40.3958C51.2802 39.6196 50.3282 37.967 50.3282 37.967L46.2275 30.5552L40.3449 40.8716C38.8803 43.4257 40.6866 46.6057 43.6401 46.6057H48.6928H55.3809H59.384C55.3077 46.5807 54.0384 44.4523 52.1833 41.2222Z",
    fill: "url(#paint0_linear_6948_102096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7052 56.0392C68.331 55.4399 69.4299 55.1545 71.0296 55.1545H74.7716V52.9712H70.348C69.2908 52.9712 68.4006 53.0854 67.7052 53.3137C67.0234 53.542 66.4253 53.8987 65.9106 54.3982C65.3681 54.9404 64.9369 55.6111 64.6309 56.4102C64.3249 57.2236 64.1719 58.1083 64.1719 59.0358C64.1719 59.9205 64.3249 60.7767 64.6309 61.5616C64.9369 62.3464 65.3681 63.0313 65.9106 63.5736C66.4114 64.073 67.0096 64.4298 67.6773 64.6581C68.3589 64.8864 69.263 65.0006 70.348 65.0006H74.7716V62.8458H71.0296C70.1811 62.8458 69.5968 62.8173 69.263 62.7459C68.9153 62.6746 68.5954 62.5604 68.331 62.3892C67.8025 62.0467 67.399 61.6044 67.1348 61.0478C66.8844 60.5056 66.7592 59.8207 66.7592 59.0215C66.7592 57.6516 67.0792 56.6385 67.7052 56.0392Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1406 65.029H45.5734V62.9171H37.6862V59.9061H44.5718V57.9084H37.6862V55.1115H45.5734V52.9854H35.1406V65.029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1738 52.9854L53.0564 59.0072L48.1738 65.029H51.3315L55.1846 60.2629V57.7657L51.3315 52.9854H48.1738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.027 52.9854L56.1738 57.7657V60.2629L60.027 65.029H63.1846L58.2882 59.0072L63.1846 52.9854H60.027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9167 58.9215L20.2289 52.9854H17.8086V65.029H20.3541V56.9951L24.4159 61.9895H25.4035L29.4653 56.9523V65.029H32.0109V52.9854H29.6184L24.9167 58.9215Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6948_102096",
    x: 0.5,
    y: 0.40625,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6948_102096"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6948_102096"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6948_102096",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6948_102096",
    x1: 38.2454,
    y1: 36.1961,
    x2: 56.5903,
    y2: 42.8043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003087"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6948_102096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(5.5 9.40625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexcIcon);
export default __webpack_public_path__ + "static/media/mexc-icon.11ace8cac3e71fad59a7ee6b9f7bfed5.svg";
export { ForwardRef as ReactComponent };